import { Box, Typography } from "@mui/material";
import { t } from "i18next";
import CustomButton from "../customComponent/CustomButton";
import CustomInput from "../customComponent/CustomInput";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CustomSelect from "../customComponent/CustomSelect";
import { ISelectOption } from "@types";
import { useRecoilState } from "recoil";
import { selectedAlgoState } from "../../recoil";
import CustomNumberInput from "../customComponent/CustomNumberInput";
import { toast } from "react-toastify";
import { PreClassStep } from "@types";

export default function AlgoFirstStep({ setCurrentStep }: PreClassStep) {
  const { id } = useParams();
  const options = [
    { id: "null", name: "선택해주세요" },
    { id: "bd31fe2a-4c6a-4919-bebb-47795f578080", name: "A 알고리즘" },
    { id: "b8e0312e-2ba7-41bc-b4f2-76fef881dd0e", name: "B 알고리즘" },
    { id: "e7eb3350-efee-41db-96e8-bf91ea2a28b4", name: "C 알고리즘" },
    { id: "28c20f9b-1edd-4948-b275-0315d417edb6", name: "D 알고리즘" },
  ];
  const [selectedOption, setSelectedOption] = useState<string>(options[0].name);
  const [selectedAlgoId, setSelectedAlgoId] = useState<string | null>(
    options[0].id
  );
  const [selectedAlgo, setSelectedAlgo] = useRecoilState(selectedAlgoState);
  const [next, setNext] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleAlgoChange = (value: ISelectOption["name"] | null) => {
    if (value) {
      setSelectedOption(value);
      const algoId = options.find((option) => option.name === value);
      const id = algoId ? algoId.id : null;
      setSelectedAlgoId(id);
      setSelectedAlgo((prev) => ({
        ...prev,
        algoId: id,
        algoName: value,
      }));
    }
  };

  const handleClassChange = (
    event:
      | React.FocusEvent<HTMLInputElement>
      | React.PointerEvent
      | React.KeyboardEvent,
    value: number | null
  ) => {
    // setClassCount(value);
    setSelectedAlgo((prev) => ({
      ...prev,
      classCount: value,
    }));
  };

  const handleSelect = () => {
    if (selectedAlgo.algoId === "null" || !selectedAlgo.algoId) {
      toast.warning("선택된 알고리즘이 존재하지 않습니다.");
    } else {
      setCurrentStep(3);
    }
  };

  const handleNext = () => {
    setNext(true);
    setTimeout(() => setIsVisible(true), 10);
  };

  const handleSkip = () => {
    console.log(selectedAlgo.classCount);
    setCurrentStep(2);

    let newLabels: string[];
    newLabels = Array.from({ length: selectedAlgo.classCount! }, (_, index) =>
      String.fromCharCode(65 + index)
    );
    setSelectedAlgo((prev) => ({
      ...prev,
      labels: newLabels,
    }));
  };

  useEffect(() => {
    if (!next) {
      setIsVisible(false);
    }
  }, [next]);

  return (
    <>
      <Typography>{t("ClassCount") + " " + t("Select")}</Typography>
      <Box sx={{ mb: 1, display: "flex", gap: "5px" }}>
        <CustomNumberInput
          required={true}
          value={selectedAlgo.classCount}
          onChange={handleClassChange}
        />
        {!next && (
          <CustomButton
            text={t("Next")}
            variant="outlined"
            onClick={handleNext}
          />
        )}
      </Box>
      {next && (
        <Box
          sx={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(50px)",
            transition: "transform 0.4s ease-in-out, opacity 0.4s ease-in-out",
          }}
        >
          <Typography>{t("SelectAlgorithm")}</Typography>
          <CustomSelect
            options={options}
            value={selectedOption}
            onChange={handleAlgoChange}
            width="400px"
          />
          <Box sx={{ display: "flex", gap: "5px", mt: 1 }}>
            <CustomButton
              text={t("Select")}
              variant="contained"
              onClick={handleSelect}
            />
            <CustomButton
              text={t("Skip")}
              variant="outlined"
              onClick={handleSkip}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
